export default "__VITE_ASSET__YRsbucLK__"